module.exports = __webpack_public_path__ + "img/amigaloly.92af3d99.jpg";